import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const getPendingInvitation = async ({ headers, reason, }) => {
    try {
        const { data, error, response } = await webserveruserClient.GET('/rest/enterprise/user/pending-invitation', reason, {
            headers,
            timeoutMs: getQueryTimeoutMs({ productionMs: 2000 }),
            numRetries: 1,
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
                details: {
                    reason,
                },
            });
        }
        return data.pending_invitation ?? null;
    }
    catch (err) {
        logger.error(err);
        return null;
    }
};
//# sourceMappingURL=getPendingInvitation.js.map